<template>
  <header id="header">
    <div class="inner_box clearfix">
      <router-link to="/">
        <v-avatar size="85"
          ><v-img
            src="@/assets/img/common/logotmp.png"
            alt="OnCrewSoft" /></v-avatar
      ></router-link>

      <nav>
        <ul id="gnb">
          <li>
            <router-link to="/sees/seesjobmind"
              >Business Automation (업무 자동화)</router-link
            >
            <ul class="deps2">
              <li>
                <router-link to="/sees/seessysmind"
                  >SYSMIND (서버운영자동화)</router-link
                >
                <ul class="deps3">
                  <li>
                    <router-link to="/sees/seessysmind"
                      >SYSMIND 소개</router-link
                    >
                  </li>
                </ul>
              </li>
              <li>
                <router-link to="/sees/seesjobmind"
                  >JOBMIND (배치스케줄러)</router-link
                >
                <ul class="deps3">
                  <li>
                    <router-link to="/sees/seesjobmind"
                      >JOBMIND 소개</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/sees/seesjobmind#features-title"
                      >JOBMIND 특장점</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/sees/seesjobmind#architecture-title"
                      >JOBMIND 구성도</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/sees/seesjobmind#reference-title"
                      >주요 실적</router-link
                    >
                  </li>
                </ul>
              </li>
              <li>
                <router-link to="/sees/seescronmind"
                  >CRONMIND (크론탭관리)</router-link
                >
                <ul class="deps3">
                  <li>
                    <router-link to="/sees/seescronmind"
                      >CRONMIND 소개</router-link
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <router-link to="/product/cubeone">Product</router-link>
            <ul class="deps2 pddeps">
              <li>
                <router-link to="/product/cubeone">Cubeone</router-link>
                <ul class="deps3">
                  <li>
                    <router-link to="/product/cubeone"
                      >ABOUT CUBEONE</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/product/cubeone#plugin"
                      >Plug-in</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/product/cubeone#api">API</router-link>
                  </li>
                  <li>
                    <router-link to="/product/cubeone#file">File</router-link>
                  </li>
                  <li>
                    <router-link to="/product/cubeone#salt">Salt</router-link>
                  </li>
                </ul>
              </li>
              <li>
                <router-link to="/product/conversionVue"
                  >Conversion</router-link
                >
                <ul class="deps3">
                  <li>
                    <router-link to="/product/conversionVue"
                      >About Conversion</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/product/conversionVue#onwatch"
                      >Smart Analyzer™</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/product/conversionVue#SmartFresh"
                      >Server Conversion</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/product/conversionVue#SmartBlue"
                      >Database Conversion</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/product/conversionVue#SmartBridge"
                      >Application Conversion</router-link
                    >
                  </li>
                </ul>
              </li>
              <!-- <li>
                <router-link to="/product/ediPlatform">DiCentral</router-link>
                <ul class="deps3">
                  <li>
                    <router-link to="/oncrew/product/ediPlatform"
                      >EDI Platform</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/oncrew/product/ediService"
                      >EDI Service</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/oncrew/product/ediBusiness"
                      >EDI Business</router-link
                    >
                  </li>
                </ul>
              </li> -->
              <li>
                <router-link to="/quest/shareplex">QUEST</router-link>
                <ul class="deps3">
                  <li>
                    <router-link to="/quest/shareplex">SharePlex</router-link>
                  </li>
                  <!--
                  <li>
                    <router-link to="/quest/erwinVue">ErWin</router-link>
                  </li>
                  -->
                  <li>
                    <router-link to="/quest/liveReorg">LiveReorg</router-link>
                  </li>
                  <li>
                    <router-link to="/quest/adsecure">AD Secure</router-link>
                  </li>
                  <li>
                    <router-link to="/quest/toadVue">Toad</router-link>
                  </li>
                </ul>
              </li>
              <li>
                <router-link to="/linkrai/linkRaiVue">linkRai</router-link>
                <ul class="deps3">
                  <li>
                    <router-link to="/linkrai/linkRaiVue"
                      >ABOUT linkRai</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/linkrai/linkRaiVue#skills"
                      >linkRai 기능</router-link
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <router-link to="/common/companyVue">Company</router-link>
            <ul class="deps2">
              <li>
                <router-link to="/common/companyVue">회사소개</router-link>
                <ul class="deps3">
                  <li>
                    <router-link to="/common/companyVue"
                      >일반 소개 & 인사말</router-link
                    >
                  </li>
                </ul>
              </li>
              <li>
                <router-link to="/common/referenceVue">주요 고객사</router-link>
                <ul class="deps3">
                  <li>
                    <router-link to="/common/referenceVue"
                      >주요 고객사 현황</router-link
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <router-link to="/common/noticeVue">Notice</router-link>
          </li>
        </ul>
      </nav>
    </div>
    <a href="javascript:;" id="btn_menu"><span>메뉴열기</span></a>
  </header>
  <article id="totalMenu">
    <div class="bg"></div>
    <nav class="inner_box">
      <a href="javascript:;" id="t_close">닫기</a>
    </nav>
  </article>
</template>

<script>
import $ from "jquery";

export default {
  mounted() {
    var $gnb = $("#gnb"),
      $gnb_li = $("#gnb > li"),
      $totalMenu = $("#totalMenu"),
      $totalMenu_nav = $totalMenu.find("nav"),
      $btn_sitemap = $("#btn_sitemap"),
      $t_close = $("#t_close"),
      $btn_menu = $("#btn_menu"),
      $totalMenu_bg = $("#totalMenu .bg");

    $gnb_li.hover(function () {
      $(this).find(".deps2").stop(true, true).slideToggle(0);
    });

    $btn_menu.click(function () {
      $totalMenu_bg.fadeIn();
      $totalMenu_nav.animate({ right: 0 });
    });

    //total menu
    $gnb.clone().appendTo($totalMenu.find("nav")).attr("id", "gnbT");

    var $gnbT_li = $("#gnbT li"),
      $gnbT_deps3 = $("#gnbT .deps3"),
      $gnbT_deps2_a = $("#gnbT .deps2 > li > a");

    $gnbT_deps2_a.click(function () {
      if ($totalMenu.css("position") !== "fixed") {
        if ($(this).next().css("display") === "none") {
          $gnbT_li.removeClass("ov");
          $gnbT_deps3.slideUp(200);
          $(this).parents("li").addClass("ov");
          $(this).next().slideDown(200);
        } else {
          $(this).parents("li").removeClass("ov");
          $(this).next().slideUp(200);
        }
        return false;
      }
    });

    //같은 페이지에서 메뉴의 deps3 클릭시 닫히지 않던 것 수정
    $gnbT_deps3.click(function () {
      if ($totalMenu.css("position") !== "fixed") {
        $(this).slideUp(200);
        $gnbT_li.removeClass("ov");

        m_Close();
      }
    });

    function m_Close() {
      $totalMenu_bg.fadeOut();
      $totalMenu_nav.animate({ right: -640 });
    }

    $totalMenu_bg.click(function () {
      if ($totalMenu.css("position") !== "fixed") {
        m_Close();
      }
    });

    // sitemap
    $btn_sitemap.click(function () {
      $("html, body").css({ height: "100%", overflow: "hidden" });
      $totalMenu.stop(true, true).fadeIn();
    });

    $t_close.click(function () {
      if ($totalMenu.css("position") !== "fixed") {
        m_Close();
      } else {
        $("html, body").css({ height: "auto", overflow: "visible" });
        $totalMenu.stop(true, true).fadeOut();
      }
    });

    function init() {
      $totalMenu_bg.hide();
      $gnbT_li.removeClass("ov");

      if ($totalMenu.css("position") !== "fixed") {
        $totalMenu_nav.css({ right: -640 });
        $gnbT_deps3.not(".on .on .deps3").hide();
      } else {
        $totalMenu_nav.css({ right: "auto" });
        $gnbT_deps3.show();
      }
    }

    init();

    $(window).on("resize", function () {
      init();
    });

    // btn_top
    $("#btn_top").click(function () {
      $("body,html").animate({ scrollTop: 0 });
    });
  },
};
</script>

<style></style>
